import { Entity } from '@adornis/baseql/decorators.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { Partner } from './Partner.js';

/**
 * @entity Politic
 */
@Entity()
export class Politic extends Partner {
  static override _class = 'Politic';

  override get type() {
    return KooperationsPartner.POLITIC;
  }
}
